<style>
  .feather-icon{
    line-height: 24px;
    vertical-align: middle;
  }
</style>
<template>
   <vs-td>
      <div class="device-info">
        <div class="shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 bg-warning-25" v-if="status">
          <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-warning"  />
        </div>
        <div class="shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 bg-grey-light" v-else>
          <feather-icon icon="MinusIcon" svgClasses="h-5 w-5 text-gray"/>
        </div>
        <div class="device-text-container pl-2">
          <span class="main-info" v-if="status">{{messageTrue != undefined ? messageTrue :$t("Messages.Alert")}}</span>
          <span class="main-info" v-if="!status">{{messageFalse != undefined ? messageFalse :$t("Messages.None")}}</span>
        </div>
      </div>
    </vs-td>
</template>
<script>
export default {
  props:{
    status: Boolean,
    messageTrue: String,
    messageFalse: String
  }
}
</script>